export interface NavLink {
  label: string
  href: string
  description?: string
}

export interface NavGroup {
  label: string
  href: string
  columns?: NavGroupColumn[]
}

export interface NavGroupColumn {
  heading: string
  links: NavLink[]
}

export const primaryNav: NavGroup[] = [
  { label: 'Products', href: '/products' },
  { label: 'Solutions', href: '/solutions' },
  { label: 'Industries', href: '/industries' },
  { label: 'Services', href: '/services' },
  { label: 'Case Studies', href: '/case-studies' },
  { label: 'Resources', href: '/resources' },
  { label: 'About', href: '/about' },
]

export const footerNav = {
  products: [
    { label: 'MediSure360 HMIS', href: '/products/medisure360-hmis' },
    { label: 'MediSure360 Insure', href: '/products/medisure360-insure' },
    { label: 'GenSure360', href: '/products/gensure360' },
    { label: 'Life360', href: '/products/life360' },
    { label: 'FleetCore360', href: '/products/fleetcore360' },
    { label: 'CMMS360', href: '/products/cmms360' },
    { label: 'Freight360', href: '/products/freight360' },
    { label: 'Property360', href: '/products/property360' },
  ],
  industries: [
    { label: 'Healthcare', href: '/industries#healthcare' },
    { label: 'Insurance', href: '/industries#insurance' },
    { label: 'Government', href: '/industries#government' },
    { label: 'Logistics', href: '/industries#logistics' },
    { label: 'Manufacturing', href: '/industries#manufacturing' },
    { label: 'Education', href: '/industries#education' },
  ],
  solutions: [
    { label: 'Digital Transformation', href: '/solutions#digital-transformation' },
    { label: 'Artificial Intelligence', href: '/solutions#ai' },
    { label: 'Asset Management', href: '/solutions#asset-management' },
    { label: 'Business Intelligence', href: '/solutions#business-intelligence' },
  ],
  resources: [
    { label: 'Resources Hub', href: '/resources' },
    { label: 'Case Studies', href: '/case-studies' },
    { label: 'Blog', href: '/blog' },
    { label: 'Support', href: '/support' },
  ],
  company: [
    { label: 'About', href: '/about' },
    { label: 'Services', href: '/services' },
    { label: 'Partners', href: '/partners' },
    { label: 'Careers', href: '/careers' },
    { label: 'Contact', href: '/contact' },
  ],
  legal: [
    { label: 'Privacy Policy', href: '/legal/privacy' },
    { label: 'Terms of Service', href: '/legal/terms' },
    { label: 'Security', href: '/legal/security' },
  ],
}
